// extracted by css-extract-rspack-plugin
export default {"timeline":"ME4IGX","row":"tTmPbN","dot":"zwd93l","date":"lLJTgZ","header":"QvbIa8","icon":"GYuv4m","body":"yu8EJU","introBody":"IXld1N","todayBadge":"FPaeig"};